import React, { useEffect, useState } from 'react'
import * as $ from 'jquery'
import { ModalFormWrapper } from '../../../../../../../../../itrust_common/components/others'
import { formatVersantCodeLabel, normalizeVersantCodes } from '../versantClaimHelper'

const FORM_NAME = 'VersantHcpcsDiagnosisForm'

export default function VersantHcpcsDiagnosisModal({
  open,
  hcpcsCode,
  hcpcsDescription,
  availableDiagnosisCodes = [],
  selectedDiagnosisCodes = [],
  onCancel,
  onSelect,
}) {
  const available = normalizeVersantCodes(availableDiagnosisCodes)
  const [checkedCodes, setCheckedCodes] = useState([])
  const [primaryCode, setPrimaryCode] = useState('')

  useEffect(() => {
    if (!open) return
    const selected = normalizeVersantCodes(selectedDiagnosisCodes)
    setCheckedCodes(selected.map((item) => item.code))
    setPrimaryCode(selected.find((item) => item.primary)?.code || selected[0]?.code || '')
  }, [open, selectedDiagnosisCodes])

  useEffect(() => {
    const $modal = $(`#${FORM_NAME}-modal`)
    if (open) $modal.modal('show')
    else $modal.modal('hide')
  }, [open])

  const toggleCode = (code) => {
    setCheckedCodes((prev) => {
      const next = prev.includes(code) ? prev.filter((item) => item !== code) : [...prev, code]
      if (!next.includes(primaryCode)) {
        setPrimaryCode(next[0] || '')
      }
      return next
    })
  }

  const closeModal = () => {
    $(`#${FORM_NAME}-modal`).modal('hide')
    onCancel()
  }

  const handleSelect = () => {
    const next = available
      .filter((item) => checkedCodes.includes(item.code))
      .map((item) => ({
        ...item,
        primary: item.code === primaryCode,
      }))
    onSelect(next)
    $(`#${FORM_NAME}-modal`).modal('hide')
  }

  return (
    <div className="inner-modal">
      <ModalFormWrapper
        formName={FORM_NAME}
        hideHeader
        modalSize="modal-lg"
        modalContentClasses="border-0 rounded shadow-lg"
        handleEditCancel={closeModal}
      >
        <div className="modal-header align-items-center border-0">
          <h5 className="text-dark mb-0">Select Diagnosis Codes</h5>
          <div className="d-flex flex-row">
            <button type="button" className="btn btn-outline-primary mr-7" onClick={closeModal}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSelect}
              disabled={!available.length}
            >
              Select
            </button>
          </div>
        </div>

        <div className="px-6 pb-6">
          <div className="mb-5">
            <div><strong>HCPCS Codes:</strong> {hcpcsCode || '-'}</div>
            <div className="text-muted"><strong>Description:</strong> {hcpcsDescription || '-'}</div>
          </div>

          {available.length === 0 ? (
            <p className="text-muted mb-0">No diagnosis codes available. Please add diagnosis codes in the previous step.</p>
          ) : (
            <div className="border rounded">
              {available.map((code) => {
                const checked = checkedCodes.includes(code.code)
                return (
                  <div key={code.code} className="d-flex align-items-center justify-content-between px-4 py-3">
                    <label className="d-flex align-items-start mb-0 flex-grow-1 mr-4">
                      <input
                        type="checkbox"
                        className="mt-1 mr-3"
                        checked={checked}
                        onChange={() => toggleCode(code.code)}
                      />
                      <span>{formatVersantCodeLabel(code)}</span>
                    </label>
                    <label className={`mb-0 d-flex align-items-center ${checked ? '' : 'text-muted'}`}>
                      <input
                        type="radio"
                        name="versant-hcpcs-primary"
                        className="mr-2"
                        disabled={!checked}
                        checked={checked && primaryCode === code.code}
                        onChange={() => setPrimaryCode(code.code)}
                      />
                      Primary
                    </label>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </ModalFormWrapper>
    </div>
  )
}
